export default "__VITE_ASSET__BtVfF4yA__"